<template>
  <div class="sound-wave-stage">
    <h1 v-if="config.title" class="sound-wave-stage__title">{{ config.title }}</h1>
    <div class="sound-wave-stage__meter" :style="meterStyle">
      <sound-wave-meter :active="active" :config="config" />
    </div>
  </div>
</template>

<script>
import SoundWaveMeter from '@/components/party/SoundWaveMeter.vue'

export default {
  name: 'PartySoundWaveStage',
  components: { SoundWaveMeter },
  props: {
    config: { type: Object, default: () => ({}) },
    active: { type: Boolean, default: false }
  },
  computed: {
    meterStyle() {
      const c = this.config || {}
      const pct = (value, fallback, min, max) => {
        const n = Number(value)
        return (Number.isFinite(n) ? Math.max(min, Math.min(max, n)) : fallback) + '%'
      }
      return {
        left: pct(c.x, 16, 0, 90),
        top: pct(c.y, 30, 0, 90),
        width: pct(c.width, 68, 10, 100),
        height: pct(c.height, 38, 10, 100)
      }
    }
  }
}
</script>

<style scoped>
.sound-wave-stage{position:absolute;inset:0;overflow:hidden}.sound-wave-stage__title{position:absolute;z-index:2;left:8%;right:8%;top:7%;margin:0;color:#fff;text-align:center;font-size:clamp(32px,4vw,76px);font-weight:700;letter-spacing:.08em;text-shadow:0 4px 28px rgba(0,0,0,.58)}.sound-wave-stage__meter{position:absolute;z-index:3}
</style>
